import * as Yup from "yup";

import { INewRithmicAccountData } from "../../../../api/rithmic/index.types";

export const COUNTRY_OPTIONS = [
  { value: "", label: "", id: 0 },
  { value: "Afghanistan", label: "Afghanistan", id: 1 },
  { value: "Åland Islands", label: "Åland Islands", id: 2 },
  { value: "Albania", label: "Albania", id: 3 },
  { value: "Algeria", label: "Algeria", id: 4 },
  { value: "American Samoa", label: "American Samoa", id: 5 },
  { value: "Andorra", label: "Andorra", id: 6 },
  { value: "Angola", label: "Angola", id: 7 },
  { value: "Anguilla", label: "Anguilla", id: 8 },
  { value: "Antarctica", label: "Antarctica", id: 9 },
  { value: "Antigua and Barbuda", label: "Antigua and Barbuda", id: 10 },
  { value: "Argentina", label: "Argentina", id: 11 },
  { value: "Armenia", label: "Armenia", id: 12 },
  { value: "Aruba", label: "Aruba", id: 13 },
  { value: "Australia", label: "Australia", id: 14 },
  { value: "Austria", label: "Austria", id: 15 },
  { value: "Azerbaijan", label: "Azerbaijan", id: 16 },
  { value: "Bahamas", label: "Bahamas", id: 17 },
  { value: "Bahrain", label: "Bahrain", id: 18 },
  { value: "Bangladesh", label: "Bangladesh", id: 19 },
  { value: "Barbados", label: "Barbados", id: 20 },
  { value: "Belarus", label: "Belarus", id: 21 },
  { value: "Belgium", label: "Belgium", id: 22 },
  { value: "Belize", label: "Belize", id: 23 },
  { value: "Benin", label: "Benin", id: 24 },
  { value: "Bermuda", label: "Bermuda", id: 25 },
  { value: "Bhutan", label: "Bhutan", id: 26 },
  { value: "Bolivia", label: "Bolivia", id: 27 },
  { value: "Bosnia and Herzegovina", label: "Bosnia and Herzegovina", id: 28 },
  { value: "Botswana", label: "Botswana", id: 29 },
  { value: "Bouvet Island", label: "Bouvet Island", id: 30 },
  { value: "Brazil", label: "Brazil", id: 31 },
  { value: "British Indian Ocean Territory", label: "British Indian Ocean Territory", id: 32 },
  { value: "Brunei Darussalam", label: "Brunei Darussalam", id: 33 },
  { value: "Bulgaria", label: "Bulgaria", id: 34 },
  { value: "Burkina Faso", label: "Burkina Faso", id: 35 },
  { value: "Burundi", label: "Burundi", id: 36 },
  { value: "Cambodia", label: "Cambodia", id: 37 },
  { value: "Cameroon", label: "Cameroon", id: 38 },
  { value: "Canada", label: "Canada", id: 39 },
  { value: "Cape Verde", label: "Cape Verde", id: 40 },
  { value: "Cayman Islands", label: "Cayman Islands", id: 41 },
  { value: "Central African Republic", label: "Central African Republic", id: 42 },
  { value: "Chad", label: "Chad", id: 43 },
  { value: "Chile", label: "Chile", id: 44 },
  { value: "China", label: "China", id: 45 },
  { value: "Christmas Island", label: "Christmas Island", id: 46 },
  { value: "Cocos (Keeling) Islands", label: "Cocos (Keeling) Islands", id: 47 },
  { value: "Colombia", label: "Colombia", id: 48 },
  { value: "Comoros", label: "Comoros", id: 49 },
  { value: "Congo", label: "Congo", id: 50 },
  {
    value: "Congo, The Democratic Republic of The",
    label: "Congo, The Democratic Republic of The",
    id: 51,
  },
  { value: "Cook Islands", label: "Cook Islands", id: 52 },
  { value: "Costa Rica", label: "Costa Rica", id: 53 },
  { value: "Cote D'ivoire", label: "Cote D'ivoire", id: 54 },
  { value: "Croatia", label: "Croatia", id: 55 },
  { value: "Cuba", label: "Cuba", id: 56 },
  { value: "Cyprus", label: "Cyprus", id: 57 },
  { value: "Czech Republic", label: "Czech Republic", id: 58 },
  { value: "Denmark", label: "Denmark", id: 59 },
  { value: "Djibouti", label: "Djibouti", id: 60 },
  { value: "Dominica", label: "Dominica", id: 61 },
  { value: "Dominican Republic", label: "Dominican Republic", id: 62 },
  { value: "Ecuador", label: "Ecuador", id: 63 },
  { value: "Egypt", label: "Egypt", id: 64 },
  { value: "El Salvador", label: "El Salvador", id: 65 },
  { value: "Equatorial Guinea", label: "Equatorial Guinea", id: 66 },
  { value: "Eritrea", label: "Eritrea", id: 67 },
  { value: "Estonia", label: "Estonia", id: 68 },
  { value: "Ethiopia", label: "Ethiopia", id: 69 },
  { value: "Falkland Islands (Malvinas)", label: "Falkland Islands (Malvinas)", id: 70 },
  { value: "Faroe Islands", label: "Faroe Islands", id: 71 },
  { value: "Fiji", label: "Fiji", id: 72 },
  { value: "Finland", label: "Finland", id: 73 },
  { value: "France", label: "France", id: 74 },
  { value: "French Guiana", label: "French Guiana", id: 75 },
  { value: "French Polynesia", label: "French Polynesia", id: 76 },
  { value: "French Southern Territories", label: "French Southern Territories", id: 77 },
  { value: "Gabon", label: "Gabon", id: 78 },
  { value: "Gambia", label: "Gambia", id: 79 },
  { value: "Georgia", label: "Georgia", id: 80 },
  { value: "Germany", label: "Germany", id: 81 },
  { value: "Ghana", label: "Ghana", id: 82 },
  { value: "Gibraltar", label: "Gibraltar", id: 83 },
  { value: "Greece", label: "Greece", id: 84 },
  { value: "Greenland", label: "Greenland", id: 85 },
  { value: "Grenada", label: "Grenada", id: 86 },
  { value: "Guadeloupe", label: "Guadeloupe", id: 87 },
  { value: "Guam", label: "Guam", id: 88 },
  { value: "Guatemala", label: "Guatemala", id: 89 },
  { value: "Guernsey", label: "Guernsey", id: 90 },
  { value: "Guinea", label: "Guinea", id: 91 },
  { value: "Guinea-bissau", label: "Guinea-bissau", id: 92 },
  { value: "Guyana", label: "Guyana", id: 93 },
  { value: "Haiti", label: "Haiti", id: 94 },
  {
    value: "Heard Island and Mcdonald Islands",
    label: "Heard Island and Mcdonald Islands",
    id: 95,
  },
  { value: "Holy See (Vatican City State)", label: "Holy See (Vatican City State)", id: 96 },
  { value: "Honduras", label: "Honduras", id: 97 },
  { value: "Hong Kong", label: "Hong Kong", id: 98 },
  { value: "Hungary", label: "Hungary", id: 99 },
  { value: "Iceland", label: "Iceland", id: 100 },
  { value: "India", label: "India", id: 101 },
  { value: "Indonesia", label: "Indonesia", id: 102 },
  { value: "Iran, Islamic Republic of", label: "Iran, Islamic Republic of", id: 103 },
  { value: "Iraq", label: "Iraq", id: 104 },
  { value: "Ireland", label: "Ireland", id: 105 },
  { value: "Isle of Man", label: "Isle of Man", id: 106 },
  { value: "Israel", label: "Israel", id: 107 },
  { value: "Italy", label: "Italy", id: 108 },
  { value: "Jamaica", label: "Jamaica", id: 109 },
  { value: "Japan", label: "Japan", id: 110 },
  { value: "Jersey", label: "Jersey", id: 111 },
  { value: "Jordan", label: "Jordan", id: 112 },
  { value: "Kazakhstan", label: "Kazakhstan", id: 113 },
  { value: "Kenya", label: "Kenya", id: 114 },
  { value: "Kiribati", label: "Kiribati", id: 115 },
  {
    value: "Korea, Democratic People's Republic of",
    label: "Korea, Democratic People's Republic of",
    id: 116,
  },
  { value: "Korea, Republic of", label: "Korea, Republic of", id: 117 },
  { value: "Kuwait", label: "Kuwait", id: 118 },
  { value: "Kyrgyzstan", label: "Kyrgyzstan", id: 119 },
  { value: "Lao People's Democratic Republic", label: "Lao People's Democratic Republic", id: 120 },
  { value: "Latvia", label: "Latvia", id: 121 },
  { value: "Lebanon", label: "Lebanon", id: 122 },
  { value: "Lesotho", label: "Lesotho", id: 123 },
  { value: "Liberia", label: "Liberia", id: 124 },
  { value: "Libyan Arab Jamahiriya", label: "Libyan Arab Jamahiriya", id: 125 },
  { value: "Liechtenstein", label: "Liechtenstein", id: 126 },
  { value: "Lithuania", label: "Lithuania", id: 127 },
  { value: "Luxembourg", label: "Luxembourg", id: 128 },
  { value: "Macao", label: "Macao", id: 129 },
  { value: "Macedonia, The Former Yugoslav Republic of", label: "", id: 130 },
  { value: "Madagascar", label: "Madagascar", id: 131 },
  { value: "Malaysia", label: "Malaysia", id: 132 },
  { value: "Maldives", label: "Maldives", id: 133 },
  { value: "Mali", label: "Mali", id: 134 },
  { value: "Malta", label: "Malta", id: 135 },
  { value: "Marshall Islands", label: "Marshall Islands", id: 136 },
  { value: "Martinique", label: "Martinique", id: 137 },
  { value: "Mauritania", label: "Mauritania", id: 138 },
  { value: "Mauritius", label: "Mauritius", id: 139 },
  { value: "Mayotte", label: "Mayotte", id: 140 },
  { value: "Mexico", label: "Mexico", id: 141 },
  { value: "Micronesia, Federated States of", label: "Micronesia, Federated States of", id: 142 },
  { value: "Moldova, Republic of", label: "Moldova, Republic of", id: 143 },
  { value: "Monaco", label: "Monaco", id: 144 },
  { value: "Mongolia", label: "Mongolia", id: 145 },
  { value: "Montenegro", label: "Montenegro", id: 146 },
  { value: "Montserrat", label: "Montserrat", id: 147 },
  { value: "Morocco", label: "Morocco", id: 148 },
  { value: "Mozambique", label: "Mozambique", id: 149 },
  { value: "Myanmar", label: "Myanmar", id: 150 },
  { value: "Namibia", label: "Namibia", id: 151 },
  { value: "Nauru", label: "Nauru", id: 152 },
  { value: "Nepal", label: "Nepal", id: 153 },
  { value: "Netherlands", label: "Netherlands", id: 154 },
  { value: "Netherlands Antilles", label: "Netherlands Antilles", id: 155 },
  { value: "New Caledonia", label: "New Caledonia", id: 156 },
  { value: "New Zealand", label: "New Zealand", id: 157 },
  { value: "Nicaragua", label: "Nicaragua", id: 158 },
  { value: "Niger", label: "Niger", id: 159 },
  { value: "Nigeria", label: "Nigeria", id: 160 },
  { value: "Niue", label: "Niue", id: 161 },
  { value: "Norfolk Island", label: "Norfolk Island", id: 162 },
  { value: "Northern Mariana Islands", label: "Northern Mariana Islands", id: 163 },
  { value: "Norway", label: "Norway", id: 164 },
  { value: "Oman", label: "Oman", id: 165 },
  { value: "Pakistan", label: "Pakistan", id: 166 },
  { value: "Palau", label: "Palau", id: 167 },
  { value: "Palestinian Territory, Occupied", label: "Palestinian Territory, Occupied", id: 168 },
  { value: "Panama", label: "Panama", id: 169 },
  { value: "Papua New Guinea", label: "Papua New Guinea", id: 170 },
  { value: "Paraguay", label: "Paraguay", id: 171 },
  { value: "Peru", label: "Peru", id: 172 },
  { value: "Philippines", label: "Philippines", id: 173 },
  { value: "Pitcairn", label: "Pitcairn", id: 174 },
  { value: "Poland", label: "Poland", id: 175 },
  { value: "Portugal", label: "Portugal", id: 176 },
  { value: "Puerto Rico", label: "Puerto Rico", id: 177 },
  { value: "Qatar", label: "Qatar", id: 178 },
  { value: "Reunion", label: "Reunion", id: 179 },
  { value: "Romania", label: "Romania", id: 180 },
  { value: "Russian Federation", label: "Russian Federation", id: 181 },
  { value: "Rwanda", label: "Rwanda", id: 182 },
  { value: "Saint Helena", label: "Saint Helena", id: 183 },
  { value: "Saint Kitts and Nevis", label: "Saint Kitts and Nevis", id: 184 },
  { value: "Saint Lucia", label: "Saint Lucia", id: 185 },
  { value: "Saint Pierre and Miquelon", label: "Saint Pierre and Miquelon", id: 186 },
  { value: "Saint Vincent and The Grenadines", label: "Saint Vincent and The Grenadines", id: 187 },
  { value: "Samoa", label: "Samoa", id: 188 },
  { value: "San Marino", label: "San Marino", id: 189 },
  { value: "Sao Tome and Principe", label: "Sao Tome and Principe", id: 190 },
  { value: "Saudi Arabia", label: "Saudi Arabia", id: 191 },
  { value: "Senegal", label: "Senegal", id: 192 },
  { value: "Serbia", label: "Serbia", id: 193 },
  { value: "Seychelles", label: "Seychelles", id: 194 },
  { value: "Sierra Leone", label: "Sierra Leone", id: 195 },
  { value: "Singapore", label: "Singapore", id: 196 },
  { value: "Slovakia", label: "Slovakia", id: 197 },
  { value: "Slovenia", label: "Slovenia", id: 198 },
  { value: "Solomon Islands", label: "Solomon Islands", id: 199 },
  { value: "Somalia", label: "Somalia", id: 200 },
  { value: "South Africa", label: "South Africa", id: 201 },
  {
    value: "South Georgia and The South Sandwich Islands",
    label: "South Georgia and The South Sandwich Islands",
    id: 202,
  },
  { value: "Spain", label: "Spain", id: 203 },
  { value: "Sri Lanka", label: "Sri Lanka", id: 204 },
  { value: "Sudan", label: "Sudan", id: 205 },
  { value: "Suriname", label: "Suriname", id: 206 },
  { value: "Svalbard and Jan Mayen", label: "Svalbard and Jan Mayen", id: 207 },
  { value: "Swaziland", label: "Swaziland", id: 208 },
  { value: "Sweden", label: "Sweden", id: 209 },
  { value: "Switzerland", label: "Switzerland", id: 210 },
  { value: "Syrian Arab Republic", label: "Syrian Arab Republic", id: 211 },
  { value: "Taiwan, Province of China", label: "Taiwan, Province of China", id: 212 },
  { value: "Tajikistan", label: "Tajikistan", id: 213 },
  { value: "Tanzania, United Republic of", label: "Tanzania, United Republic of", id: 214 },
  { value: "Thailand", label: "Thailand", id: 215 },
  { value: "Timor-leste", label: "Timor-leste", id: 216 },
  { value: "Togo", label: "Togo", id: 217 },
  { value: "Tokelau", label: "Tokelau", id: 218 },
  { value: "Tonga", label: "Tonga", id: 219 },
  { value: "Trinidad and Tobago", label: "Trinidad and Tobago", id: 220 },
  { value: "Tunisia", label: "Tunisia", id: 221 },
  { value: "Turkey", label: "Turkey", id: 222 },
  { value: "Turkmenistan", label: "Turkmenistan", id: 223 },
  { value: "Turks and Caicos Islands", label: "Turks and Caicos Islands", id: 224 },
  { value: "Tuvalu", label: "Tuvalu", id: 225 },
  { value: "Uganda", label: "Uganda", id: 226 },
  { value: "Ukraine", label: "Ukraine", id: 227 },
  { value: "United Arab Emirates", label: "United Arab Emirates", id: 228 },
  { value: "United Kingdom", label: "United Kingdom", id: 229 },
  { value: "United States", label: "United States", id: 230, selected: true },
  { value: "US Minor Outlying Islands", label: "US Minor Outlying Islands", id: 231 },
  { value: "Uruguay", label: "Uruguay", id: 232 },
  { value: "Uzbekistan", label: "Uzbekistan", id: 233 },
  { value: "Vanuatu", label: "Vanuatu", id: 234 },
  { value: "Venezuela", label: "Venezuela", id: 235 },
  { value: "Viet Nam", label: "Viet Nam", id: 236 },
  { value: "British Virgin Islands", label: "British Virgin Islands", id: 237 },
  { value: "US Virgin Islands", label: "US Virgin Islands", id: 238 },
  { value: "Wallis and Futuna", label: "Wallis and Futuna", id: 239 },
  { value: "Western Sahara", label: "Western Sahara", id: 240 },
  { value: "Yemen", label: "Yemen", id: 241 },
  { value: "Zambia", label: "Zambia", id: 242 },
  { value: "Zimbabwe", label: "Zimbabwe", id: 243 },
];

export const STATE_OPTIONS = [
  { abbreviation: "", value: "", label: "", id: 0 },
  { abbreviation: "AL", value: "Alabama", label: "Alabama", id: 1 },
  { abbreviation: "AK", value: "Alaska", label: "Alaska", id: 2 },
  { abbreviation: "AZ", value: "Arizona", label: "Arizona", id: 3 },
  { abbreviation: "AR", value: "Arkansas", label: "Arkansas", id: 4 },
  { abbreviation: "CA", value: "California", label: "California", id: 5 },
  { abbreviation: "CO", value: "Colorado", label: "Colorado", id: 6 },
  { abbreviation: "CT", value: "Connecticut", label: "Connecticut", id: 7 },
  { abbreviation: "DE", value: "Delaware", label: "Delaware", id: 8 },
  { abbreviation: "DC", value: "District of Columbia", label: "District of Columbia", id: 9 },
  { abbreviation: "FL", value: "Florida", label: "Florida", id: 10 },
  { abbreviation: "GA", value: "Georgia", label: "Georgia", id: 11 },
  { abbreviation: "GU", value: "Guam", label: "Guam", id: 12 },
  { abbreviation: "HI", value: "Hawaii", label: "Hawaii", id: 13 },
  { abbreviation: "ID", value: "Idaho", label: "Idaho", id: 14 },
  { abbreviation: "IL", value: "Illinois", label: "Illinois", id: 15 },
  { abbreviation: "IN", value: "Indiana", label: "Indiana", id: 16 },
  { abbreviation: "IA", value: "Iowa", label: "Iowa", id: 17 },
  { abbreviation: "KS", value: "Kansas", label: "Kansas", id: 18 },
  { abbreviation: "KY", value: "Kentucky", label: "Kentucky", id: 19 },
  { abbreviation: "LA", value: "Louisiana", label: "Louisiana", id: 20 },
  { abbreviation: "ME", value: "Maine", label: "Maine", id: 21 },
  { abbreviation: "MD", value: "Maryland", label: "Maryland", id: 22 },
  { abbreviation: "MA", value: "Massachusetts", label: "Massachusetts", id: 23 },
  { abbreviation: "MI", value: "Michigan", label: "Michigan", id: 24 },
  { abbreviation: "MN", value: "Minnesota", label: "Minnesota", id: 25 },
  { abbreviation: "MS", value: "Mississippi", label: "Mississippi", id: 26 },
  { abbreviation: "MO", value: "Missouri", label: "Missouri", id: 27 },
  { abbreviation: "MT", value: "Montana", label: "Montana", id: 28 },
  { abbreviation: "NE", value: "Nebraska", label: "Nebraska", id: 29 },
  { abbreviation: "NV", value: "Nevada", label: "Nevada", id: 30 },
  { abbreviation: "NH", value: "New Hampshire", label: "New Hampshire", id: 31 },
  { abbreviation: "NJ", value: "New Jersey", label: "New Jersey", id: 32 },
  { abbreviation: "NM", value: "New Mexico", label: "New Mexico", id: 33 },
  { abbreviation: "NY", value: "New York", label: "New York", id: 34 },
  { abbreviation: "NC", value: "North Carolina", label: "North Carolina", id: 35 },
  { abbreviation: "ND", value: "North Dakota", label: "North Dakota", id: 36 },
  {
    abbreviation: "MP",
    value: "Northern Marianas Islands",
    label: "Northern Marianas Islands",
    id: 37,
  },
  { abbreviation: "OH", value: "Ohio", label: "Ohio", id: 38 },
  { abbreviation: "OK", value: "Oklahoma", label: "Oklahoma", id: 39 },
  { abbreviation: "OR", value: "Oregon", label: "Oregon", id: 40 },
  { abbreviation: "PA", value: "Pennsylvania", label: "Pennsylvania", id: 41 },
  { abbreviation: "PR", value: "Puerto Rico", label: "Puerto Rico", id: 42 },
  { abbreviation: "RI", value: "Rhode Island", label: "Rhode Island", id: 43 },
  { abbreviation: "SC", value: "South Carolina", label: "South Carolina", id: 44 },
  { abbreviation: "SD", value: "South Dakota", label: "South Dakota", id: 45 },
  { abbreviation: "TN", value: "Tennessee", label: "Tennessee", id: 46 },
  { abbreviation: "TX", value: "Texas", label: "Texas", id: 47 },
  { abbreviation: "UT", value: "Utah", label: "Utah", id: 48 },
  { abbreviation: "VT", value: "Vermont", label: "Vermont", id: 49 },
  { abbreviation: "VA", value: "Virginia", label: "Virginia", id: 50 },
  { abbreviation: "VI", value: "Virgin Islands", label: "Virgin Islands", id: 51 },
  { abbreviation: "WA", value: "Washington", label: "Washington", id: 52 },
  { abbreviation: "WV", value: "West Virginia", label: "West Virginia", id: 53 },
  { abbreviation: "WI", value: "Wisconsin", label: "Wisconsin", id: 54 },
  { abbreviation: "WY", value: "Wyoming", label: "Wyoming", id: 55 },
];

export const PROVINCE_OPTIONS = [
  { abbreviation: "", value: "", label: "", id: 0 },
  { abbreviation: "AB", value: "Alberta", label: "Alberta", id: 1 },
  { abbreviation: "BC", value: "British Columbia", label: "British Columbia", id: 2 },
  { abbreviation: "MB", value: "Manitoba", label: "Manitoba", id: 3 },
  { abbreviation: "NB", value: "New Brunswick", label: "New Brunswick", id: 4 },
  { abbreviation: "NL", value: "Newfoundland", label: "Newfoundland", id: 5 },
  { abbreviation: "NS", value: "Nova Scotia", label: "Nova Scotia", id: 6 },
  { abbreviation: "NU", value: "Nunavut", label: "Nunavut", id: 7 },
  { abbreviation: "NT", value: "Northwest Territories", label: "Northwest Territories", id: 8 },
  { abbreviation: "ON", value: "Ontario", label: "Ontario", id: 9 },
  { abbreviation: "PE", value: "Prince Edward Island", label: "Prince Edward Island", id: 10 },
  { abbreviation: "QC", value: "Quebec", label: "Quebec", id: 11 },
  { abbreviation: "SK", value: "Saskatchewan", label: "Saskatchewan", id: 12 },
  { abbreviation: "YT", value: "Yukon", label: "Yukon", id: 13 },
];

export const EDX_ACCOUNT_TYPE_OPTIONS = [
  // { value: 1, label: "GM 25", id: 1 },
  { value: "GAU50", label: "LiveSim GAU50 (2)", id: 2 },
  // { value: "GAU75", label: "LiveSim GAU75", id: 3 },
  { value: "GAU100", label: "LiveSim GAU100 (4)", id: 4 },
  { value: "GAU150", label: "LiveSim GAU150 (5)", id: 5 },
  { value: "GAU200", label: "LiveSim GAU200 (6)", id: 6 },
  { value: "TCP25k", label: "LiveSim TCP25 (7)", id: 7 },
  { value: "TCP50k", label: "LiveSim TCP50 (8)", id: 8 },
  { value: "TCP100k", label: "LiveSim TCP100 (9)", id: 9 },
  { value: "TCP150k", label: "LiveSim TCP150 (10)", id: 10 },
  { value: "TCP200k", label: "LiveSim TCP200 (11)", id: 11 },
  { value: "TCP200_FIXED", label: "LiveSim TCP200 fixed (12)", id: 12 },
  { value: "TCP400k", label: "LiveSim TCP400 (13)", id: 13 },
];

export const EXCHANGES_OPTIONS = [
  { value: "CME", label: "CME", id: 1 },
  { value: "CBOT", label: "CBOT", id: 2 },
  { value: "NYMEX", label: "NYMEX", id: 3 },
  { value: "COMEX", label: "COMEX", id: 4 },
];

export const FUNDING_LOCATION = [
  { value: "b", label: "Bahia", id: 1 },
  { value: "h", label: "Helios", id: 2 },
];

export const ORIGINAL_ACCOUNT_TYPE = [
  { value: "x", label: "N/A (x)", id: 1 },
  { value: "a", label: "TCP 25 (a)", id: 2 },
  { value: "b", label: "TCP 50 (b)", id: 3 },
  { value: "c", label: "TCP 100 (c)", id: 4 },
];

export const ASSETS_OPTIONS = [
  { value: "6A", label: "6A, CME", id: 1 },
  { value: "6B", label: "6B, CME", id: 2 },
  { value: "6C", label: "6C, CME", id: 3 },
  { value: "6E", label: "6E, CME", id: 4 },
  { value: "6J", label: "6J, CME", id: 5 },
  { value: "6L", label: "6L, CME", id: 6 },
  { value: "6M", label: "6M, CME", id: 7 },
  { value: "6N", label: "6N, CME", id: 8 },
  { value: "6S", label: "6S, CME", id: 9 },
  { value: "BTC", label: "BTC, CME", id: 10 },
  { value: "CL", label: "CL, NYMEX", id: 11 },
  { value: "E7", label: "E7, CME", id: 12 },
  { value: "EMD", label: "EMD, CME", id: 13 },
  { value: "ES", label: "ES, CME", id: 14 },
  { value: "GC", label: "GC, COMEX", id: 15 },
  { value: "GE", label: "GE, CME", id: 16 },
  { value: "GF", label: "GF, CME", id: 17 },
  { value: "HE", label: "HE, CME", id: 18 },
  { value: "HG", label: "HG, COMEX", id: 19 },
  { value: "HO", label: "HO, NYMEX", id: 20 },
  { value: "J7", label: "J7, NYMEX", id: 21 },
  { value: "LE", label: "LE, CME", id: 22 },
  { value: "M2K", label: "M2K, CME", id: 23 },
  { value: "M6A", label: "M6A, CME", id: 24 },
  { value: "M6B", label: "M6B, CME", id: 25 },
  { value: "M6E", label: "M6E, CME", id: 26 },
  { value: "MCD", label: "MCD, CME", id: 27 },
  { value: "MCL", label: "MCL, NYMEX", id: 28 },
  { value: "MES", label: "MES, CME", id: 29 },
  { value: "MGC", label: "MGC, COMEX", id: 30 },
  { value: "MHG", label: "MHG, COMEX", id: 31 },
  { value: "MIR", label: "MIR, CME", id: 32 },
  { value: "MJY", label: "MJY, CME", id: 33 },
  { value: "MHE", label: "MHE, NYMEX", id: 34 },
  { value: "MNQ", label: "MNQ, CME", id: 35 },
  { value: "MP", label: "MP, CME", id: 36 },
  { value: "MQ", label: "MQ, NYMEX", id: 37 },
  { value: "MSF", label: "MSF, CME", id: 38 },
  { value: "MYM", label: "MYM, CBOT", id: 39 },
  { value: "N1", label: "N1, CME", id: 40 },
  { value: "NG", label: "NG, NYMEX", id: 41 },
  { value: "NK", label: "NK, CME", id: 42 },
  { value: "NQ", label: "NQ, CME", id: 43 },
  { value: "PA", label: "PA, NYMEX", id: 44 },
  { value: "PL", label: "PL, NYMEX", id: 45 },
  { value: "QC", label: "QC, COMEX", id: 46 },
  { value: "QG", label: "QG, NYMEX", id: 47 },
  { value: "QI", label: "QI, COMEX", id: 48 },
  { value: "QM", label: "QM, NYMEX", id: 49 },
  { value: "QO", label: "QO, COMEX", id: 50 },
  { value: "RB", label: "RB, COMEX", id: 51 },
  { value: "RF", label: "RF, CME", id: 52 },
  { value: "RMB", label: "RMB, CME", id: 53 },
  { value: "RP", label: "RP, CME", id: 54 },
  { value: "RTY", label: "RTY, CME", id: 55 },
  { value: "RY", label: "RY, CME", id: 56 },
  { value: "SI", label: "SI, COMEX", id: 57 },
  { value: "SIL", label: "SIL, COMEX", id: 58 },
  { value: "SP", label: "SP, CME", id: 59 },
  { value: "TN", label: "TN, CBOT", id: 60 },
  { value: "UB", label: "UB, CBOT", id: 61 },
  { value: "XC", label: "XC, CBOT", id: 62 },
  { value: "XK", label: "XK, CBOT", id: 63 },
  { value: "YM", label: "YM, CBOT", id: 64 },
  { value: "ZB", label: "ZB, CBOT", id: 65 },
  { value: "ZC", label: "ZC, CBOT", id: 66 },
  { value: "ZF", label: "ZF, CBOT", id: 67 },
  { value: "ZL", label: "ZL, CBOT", id: 68 },
  { value: "ZM", label: "ZM, CBOT", id: 69 },
  { value: "ZN", label: "ZN, CBOT", id: 70 },
  { value: "ZQ", label: "ZQ, CBOT", id: 71 },
  { value: "ZS", label: "ZS, CBOT", id: 72 },
  { value: "ZT", label: "ZT, CBOT", id: 73 },
  { value: "ZW", label: "ZW, CBOT", id: 74 },
];

export const VALIDATION_SCHEMA = Yup.object().shape({
  original_account_type: Yup.string().when("account_type", {
    is: (accountTypeValue: string) => !!accountTypeValue,
    then: Yup.string().required("Original account type is required"),
    otherwise: Yup.string().notRequired(),
  }),
  username: Yup.string().required("Username is required"),
  first: Yup.string().required("First name is required"),
  last: Yup.string().required("Last name is required"),
  // account_name: Yup.string().required("Account name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  // .when("new_user", {
  //   is: true,
  //   then: Yup.string().required("Email is required"),
  //   otherwise: Yup.string().notRequired(),
  // }),
  // password: Yup.string().required("Password is required"),
  // .when("new_user", {
  //   is: true,
  //   then: Yup.string().required("Password is required"),
  //   otherwise: Yup.string().notRequired(),
  // }),
  address1: Yup.string(),
  // .when("new_user", {
  //   is: true,
  //   then: Yup.string().required("Address 1 is required"),
  //   otherwise: Yup.string().notRequired(),
  // }),
  address2: Yup.string(),
  city: Yup.string(),
  // .when("new_user", {
  //   is: true,
  //   then: Yup.string().required("City is required"),
  //   otherwise: Yup.string().notRequired(),
  // }),
  country: Yup.string(),
  // .when("new_user", {
  //   is: true,
  //   then: Yup.string().required("Country is required"),
  //   otherwise: Yup.string().notRequired(),
  // }),
  state: Yup.string().when("country", {
    is: (value: string) => {
      return ["Canada", "United States"].includes(value);
    },
    then: Yup.string().required("State/Province is required"),
    otherwise: Yup.string().notRequired(),
  }),
  // province: Yup.object().when("country", {
  //   is: "Canada",
  //   then: Yup.object().required("Province is required"),
  //   otherwise: Yup.object().notRequired(),
  // }),
  zip: Yup.string(),
  // .when("new_user", {
  //   is: true,
  //   then: Yup.string().required("Zip is required"),
  //   otherwise: Yup.string().notRequired(),
  // }),
  account_type: Yup.string().required("Account type is required"),
  exchanges: Yup.array().min(1, "At least one exchange is required"),
  assets: Yup.array().min(1, "At least one asset is required"),
});

export const INITIAL_VALUES: INewRithmicAccountData = {
  funding_location: FUNDING_LOCATION[0].value,
  // funding_location_name: "",
  original_account_type: "",
  username: "",
  account_name: "",
  eod_trailing: true,
  first: "",
  last: "",
  email: "",
  password: "",
  address1: "",
  address2: "",
  city: "",
  country: "",
  state: "",
  province: "",
  zip: "",
  account_type: "",
  exchanges: ["CME"],
  //@ts-ignore
  assets: ASSETS_OPTIONS.filter(({ value }) => ["ES", "MES", "NQ", "MNQ"].includes(value)),
  micros: false,
  isDisabledState: true,
  existing: false,
  rithmic: "",
  counterOfAccounts: 1,
};
